import type { EmployerProfile } from '@factoryfixinc/ats-interfaces';
import { EmployerProfilePersistence } from './employer-profile.persistence';
import MeService from '../me/me.service';
import { useEmployerProfileStore } from './employer-profile.store';

export class EmployerProfileService {
  private meService = new MeService();
  private employerProfilePersistence = new EmployerProfilePersistence();
  private store = useEmployerProfileStore();

  constructor() {}

  public async updateEmployerProfile(employerUpdate: Partial<EmployerProfile>): Promise<void> {
    const employerId = this.meService.employer?.id;
    if (!employerId) return;

    try {
      await this.employerProfilePersistence.updateEmployerProfile(employerId, employerUpdate);

      const updatedProfile = await this.employerProfilePersistence.fetchEmployerProfile(employerId);
      this.store.employerProfile = updatedProfile;
    } catch (error) {
      throw error;
    }
  }

  public async fetchEmployerProfile(): Promise<EmployerProfile | undefined> {
    const employerId = this.meService.employer?.id;
    if (!employerId) return undefined;

    try {
      const profile = await this.employerProfilePersistence.fetchEmployerProfile(employerId);
      this.store.employerProfile = profile;
      return profile;
    } catch (error) {
      throw error;
    }
  }

  public async fetchAndSetEmployerProfile(): Promise<void> {
    const employerProfile = await this.fetchEmployerProfile();
    this.store.employerProfile = employerProfile;
  }

  public get employerProfile(): EmployerProfile | undefined {
    return this.store.employerProfile;
  }

  public async isStaffingAgency(): Promise<boolean> {
    const employerId = this.meService.employer?.id;
    if (!employerId) return false;

    return this.employerProfilePersistence.fetchIsStaffingAgency(employerId);
  }
}
